var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDefects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14ZM7 3.9375C8.44922 3.9375 9.625 5.11328 9.625 6.5625V7.4375C9.625 8.88672 8.44922 10.0625 7 10.0625C5.55078 10.0625 4.375 8.88672 4.375 7.4375V6.5625C4.375 5.11328 5.55078 3.9375 7 3.9375ZM5.6875 6.5625V7.4375C5.6875 8.16211 6.27539 8.75 7 8.75C7.72461 8.75 8.3125 8.16211 8.3125 7.4375V6.5625C8.3125 5.83789 7.72461 5.25 7 5.25C6.27539 5.25 5.6875 5.83789 5.6875 6.5625Z",
    fill: "#3A6035"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDefects);
export default __webpack_public_path__ + "static/media/NoDefects.d0c48cbac3328392bb1d526bf0fa8266.svg";
export { ForwardRef as ReactComponent };